<template>
  <v-container fluid>
    <v-container>
      <v-layout>
        <v-flex xs8 md2>
          <v-select
            :items="filterKeys"
            item-text="value"
            item-value="key"
            v-model="filter"
            label="篩選案件狀態"
            @change="changeFilterStatus"
          ></v-select>
        </v-flex>
      </v-layout>
    </v-container>

    <list-editor
      :column-keys="columnKeys"
      :items="items"
      :loading="loading"
      :showSearchBar="true"
      :showSearchDate="true"
      :isShowImport="false"
      :show-export-button="true"
      :searchPlaceHolder="searchPlaceHolder"
      :totalItems="getTotalItems"
      :startDate="startDate"
      :endDate="endDate"
      :sourceName="sourceName"
      :getSearchKeys="searchKeys"
      @saveData="save"
      @searchData="searchData"
      @changePage="changePage"
      @importData="importData"
      @removeData="removeData"
      @exportData="exportData"
      @openDocument="openDocument"
      @changePriorityStatus="changePriorityStatus"
    ></list-editor>
    <alert-view
      :visible="messageDialog.visible"
      :title="messageDialog.title"
      :content="messageDialog.text"
      :show-cancel="messageDialog.showCancelButton"
      @cancelEvent="messageDialog.cancel"
      @confirmEvent="messageDialog.confirm"
    >
    </alert-view>
  </v-container>
</template>

<script>
import MobileDetect from "mobile-detect";

import { mapActions, mapGetters } from "vuex";
import ListEditor from "../../components/ListEditor";
import NoticeManager from "@/utils/notice_manager";
import TableView from "@/components/TableView";
const md = new MobileDetect(window.navigator.userAgent);
const priceData = require("../../assets/credit_price");
const cityList = require("../../assets/taiwan_city");
import { getCurrentDate, exportPriceFile } from "../utils/tool";
import AlertView from "../../components/AlertView";

export default {
  name: "GrantNoticeView",
  components: { TableView, ListEditor, AlertView },
  data() {
    return {
      sourceName: "GrantNoticeView",
      pageIndex: 1,
      limit: 5,
      totalItems: 0,
      startDate: "",
      endDate: "",
      loading: false,
      searchKey: "status",
      searchValue: 0,
      searchPlaceHolder: "搜尋身分證、姓名、案件編號",
      items: [],
      selectItem: null,
      pagination: {
        pageList: 0,
        rowsPerPageItems: [5, 10, 50, 100],
        page: 1,
      },
      messageDialog: {
        title: "",
        text: "",
        visible: false,
        showCancelButton: false,
        confirm: () => {},
        cancel: () => {},
      },
      isMobile: md.phone(),
      filter: 0,
    };
  },
  created() {
    this.setDefualtDate();
    this.loadData();

    NoticeManager.addObserver("alertConfirm", () => {
      if (this.selectItem) {
        this.removeDataEvent(this.selectItem.recordId);
      }
    });
  },
  computed: {
    ...mapGetters(["getUserInfo", "getAgentInfo"]),
    canUseDelete() {
      if (
        this.getAgentInfo.agentId === "KwarcyDi4BOv75RNE5SLBOwvia32" ||
        this.getAgentInfo.agentId === "t76gyOZwV8NouQAD6WoTEH7cSzB2" ||
        this.getAgentInfo.agentId === "MXiKEOWVx8O0OxlBjab5Yro9dOr1" ||
        this.getAgentInfo.canCustomPrice === true ||
        this.isAdmin
      ) {
        return true;
      }
      return false;
    },
    columnKeys() {
      let list = [
        {
          value: "invoiceDocument",
          text: "請款文件",
          sortable: false,
          required: true,
          isShow: true,
          isEdit: false,
        },
        {
          value: "settingDocument",
          text: "設定書",
          sortable: false,
          required: true,
          isShow: true,
          isEdit: false,
        },
        {
          value: "priorityStatus",
          text: "優撥狀態",
          sortable: false,
          required: false,
          isShow: true,
          isEdit: false,
        },
        {
          value: "productId",
          text: "業務別",
          sortable: false,
          required: true,
          isShow: true,
          isEdit: false,
        },
        {
          value: "displayId",
          text: "案件編號",
          sortable: false,
          required: true,
          isShow: true,
          isEdit: false,
        },
        {
          value: "name",
          text: "姓名",
          sortable: true,
          required: true,
          isShow: true,
          isEdit: false,
        },
        {
          value: "memberId",
          text: "身分證字號",
          sortable: false,
          required: true,
          isShow: true,
          isEdit: false,
        },
        {
          value: "carId",
          text: "車號",
          sortable: false,
          required: true,
          isShow: true,
          isEdit: false,
        },
        {
          value: "installmentsNumber",
          text: "期數",
          sortable: false,
          required: true,
          isShow: true,
          isEdit: false,
        },
        {
          value: "creditPriceMonth",
          text: "期付金",
          sortable: false,
          required: true,
          isShow: true,
          isEdit: false,
        },
        {
          value: "totalPrice",
          text: "申貸金額",
          sortable: false,
          required: true,
          isShow: true,
          isEdit: false,
        },
        {
          value: "compensationPrice",
          text: "他行代償金額",
          sortable: false,
          required: true,
          isShow: true,
          isEdit: false,
        },
        {
          value: "createDate",
          text: "建立時間",
          sortable: true,
          required: false,
          disabled: true,
          isShow: true,
          isEdit: false,
        },
        // { value: 'sendDate', text: '撥款日期', sortable: true, required: true , isShow:true, isEdit:true},
        {
          value: "realPrice",
          text: "實際撥款金額",
          sortable: false,
          required: false,
          isShow: true,
          isEdit: true,
        },
        {
          value: "delete",
          text: "刪除",
          sortable: false,
          required: false,
          isShow: true,
          isEdit: false,
        },
      ];
      if (this.canUseDelete || this.getUserInfo.enableLoanhfc === true) {
        return list;
      }
      return list.filter((m) => m.value !== "delete");
    },
    isAdmin() {
      return this.getUserInfo.authority === "admin";
    },
    searchKeys() {
      return [
        { key: "name", value: "姓名" },
        { key: "memberId", value: "身分證字號" },
        { key: "displayId", value: "案件編號" },
      ];
    },
    filterKeys() {
      return [
        { key: 0, value: "待處理" },
        { key: 1, value: "已處理" },
        { key: -1, value: "全部" },
      ];
    },
    getTotalItems() {
      return this.totalItems;
    },
  },
  methods: {
    ...mapActions([
      "getPriceNoticeList",
      "deleteRealPriceInfo",
      "saveMultiPriceInfo",
      "updatePriceInfoStatus",
    ]),
    setDefualtDate() {
      let todayDate = new Date();
      todayDate.setMonth(todayDate.getMonth() - 1);
      let currentDate = todayDate.toISOString().substr(0, 10);
      const [thisYear, thisMonth, thisDay] = currentDate.split("-");
      this.startDate = `${thisYear}-${thisMonth}-01`;

      let futureDate = new Date();
      // 将当前月份加1，下移到下个月
      futureDate.setMonth(futureDate.getMonth() + 1);
      // 再获取天数即取上个月的最后一天的天数
      futureDate.setDate(0);
      let days = futureDate.getDate();

      let endDate = futureDate.toISOString().substr(0, 10);
      const [futureYear, futureMonth, futureDay] = endDate.split("-");

      this.endDate = `${futureYear}-${futureMonth}-${days}`;
      // let date = new Date();
      // //将当前月份加1，下移到下一个月
      // date.setMonth(date.getMonth() + 1);
      // //将当前的日期置为0，
      // date.setDate(0);
      // //再获取天数即取上个月的最后一天的天数
      // let days = date.getDate();
      // let currentDate = new Date().toISOString().substr(0, 10);
      // const [year, month, day] = currentDate.split("-");
      // this.startDate = `${year}-${month}-01`;
      // this.endDate = `${year}-${month}-${days}`;
    },
    openDocument(url) {
      if (url !== "") {
        window.open(url, "_blank");
      }
    },
    changePage(page) {
      this.pageIndex = page.page;
      this.limit = page.rowsPerPage;
      this.loadData();
    },
    searchData(searchInfo) {
      this.searchKey = searchInfo.searchKey;
      this.startDate = searchInfo.startDate;
      this.endDate = searchInfo.endDate;
      this.searchValue = searchInfo.keyword;
      console.log(`searchData == ${JSON.stringify(searchInfo)}`);
      this.loadData();
    },
    changeFilterStatus() {
      if (this.filter === -1) {
        this.searchKey = "";
        this.filter = -1;
        this.searchValue = "";
      } else {
        this.searchKey = "status";
        this.searchValue = this.filter;
      }
      this.loadData();
    },
    async loadData() {
      this.loading = true;
      const agentId = this.canUseDelete ? "" : this.getUserInfo.agentId;
      // console.log(`loginResult.data == ${JSON.stringify(loginResult.data)}`);
      const results = await this.getPriceNoticeList({
        searchKey: this.searchKey,
        searchValue: this.searchValue,
        start: `${this.startDate} 00:00:00`,
        end: `${this.endDate} 23:59:59`,
        pageIndex: this.pageIndex,
        limit: this.limit,
        agentId: agentId,
      });
      if (results.status === 200) {
        this.items = results.data.data.list;
        console.log(`res status === ${JSON.stringify(this.items)}`);
        this.totalItems = results.data.data.header.totalCount;
      }
      this.loading = false;
    },
    async importData(data) {
      let processData = [];
      let i = 0;
      for (let item of data) {
        let newItem = {};
        for (let key of Object.keys(item)) {
          if (key === "審件編號") {
            newItem["displayId"] = item[key];
          } else if (key === "撥款金額") {
            newItem["realPrice"] = item[key];
          } else if (key === "撥款日期") {
            newItem["sendDate"] = item[key];
          } else if (key === "車牌") {
            newItem["carId"] = item[key];
          }
        }
        processData.push(newItem);
        i += 1;
      }
      // console.log(`${JSON.stringify(processData)}`);

      this.loading = true;
      let title = "錯誤";
      let message = "";
      try {
        const res = await this.saveMultiPriceInfo({
          list: processData,
        });
        const saveResult = res.data;
        this.loading = false;
        if (saveResult) {
          if (saveResult.statusCode === 0) {
            title = "成功";
            await this.loadData();
          }
          console.log(JSON.stringify(saveResult));
          message = saveResult.message;
        }
      } catch (e) {
        this.loading = false;
        message = `發生錯誤 ${e}`;
      }

      NoticeManager.notifyObservers("showAlert", {
        title: "提示",
        text: message,
        visible: true,
        showCancelButton: false,
      });
    },
    exportData() {
      exportPriceFile(
        `優撥清單_${getCurrentDate()}`,
        this.columnKeys.filter(
          (m) =>
            m.value !== "delete" &&
            m.value !== "createDate" &&
            m.value !== "realPrice"
        ),
        this.items
      );
    },
    save() {},
    removeData(data) {
      this.selectItem = data;
      NoticeManager.notifyObservers("showAlert", {
        title: "提示",
        text: "是否要刪除紀錄？",
        visible: true,
        showCancelButton: true,
      });
      console.log(`remove ${JSON.stringify(data)}`);
    },
    async removeDataEvent(caseId) {
      await this.deleteRealPriceInfo({
        caseId: caseId,
      });
      await this.loadData();
    },
    async changePriorityStatus(item) {
      const res = await this.updatePriceInfoStatus({
        caseId: item.caseId,
        status: item.status,
      });
      this.showMessageDialog(
        "提示",
        "更新優撥狀態成功",
        true,
        async () => {
          this.loadData();
        },
        () => {}
      );
    },
    showMessageDialog(title, text, visible, confirmEvent, cancelEvent) {
      this.messageDialog.title = title;
      this.messageDialog.text = text;
      this.messageDialog.visible = visible;
      const self = this;
      this.messageDialog.confirm = () => {
        self.messageDialog.visible = false;
        if (confirmEvent) {
          confirmEvent();
        }
      };

      this.messageDialog.cancel = () => {
        self.messageDialog.visible = false;
        if (cancelEvent) {
          cancelEvent();
        }
      };
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/web/GrantNoticeView.vue